import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import LocationStore from 'stores/Location.store';
import UrlHistoryTrackerStore from 'stores/UrlHistoryTracker.store';

@withRouter
class LocationObserver extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
    LocationStore.setLastLocation(prevProps.location);
    UrlHistoryTrackerStore.setUrlHistory();
  }

  render() {
    return this.props.children;
  }
}

export default LocationObserver;



// WEBPACK FOOTER //
// ./src/common/components/LocationObserver/LocationObserver.js